import React from 'react';
import { useRouter } from 'next/navigation';
import ActiveLessonCacheService from '@/services/storage/active-lesson-cache-service';
import URLPreview from './components/URLPreview';

interface Props {
  resourceId: string;
  description: string;
  resourceURL: string;
  subunitId: string | undefined;
  unitId: string | undefined;
  courseId: string;
  activityName: string;
  onBack?: () => void;
}

export default function ResourceHandler({
  resourceId,
  description,
  resourceURL,
  subunitId,
  unitId,
  courseId,
  activityName,
  onBack,
}: Props) {
  const router = useRouter();

  const defaultOnBack = () => {
    ActiveLessonCacheService.resetLessonStateCookie();
    router.push('/student/course');
  };

  return (
    <div className='w-full lg:max-w-[1200px] md:max-w-[720px] h-full flex flex-col gap-2 mx-auto'>
      <div className='mt-4 page-card'>
        <h3>{activityName}</h3>

        <h4 className='mt-4'>{description}</h4>
        {/* TODO:: add link to Resource entity in backend, implement in FE so that it appears formatted as a link rather than just plain text */}
        <URLPreview url={resourceURL.trim()} />
      </div>
    </div>
  );
}
